import {
  CREATE_ACCOUNT,
  CREATE_ACCOUNT_SUCCESS,
  SIGN_IN,
  SIGN_IN_SUCCESS,
  SIGN_IN_MFA,
  MFA_AUTHENTICATION,
  MFA_SUCCESS,
  CLEAR_MFA_ERROR,
  TRANSACTION_TYPE,
  FORGET_PASSWORD,
  CHANGE_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  REQUEST_FAILED,
  RESEND_MFA_CODE_SUCCESS,
  CLEAR_SUCCESS_MESSAGE,
} from './types';

const INITIAL_STATE = {
  createAccountLoading: false,
  signInloading: false,
  mfaloading: false,
  session: null,
  email: null,
  error: null,
  expiry: null,
  transactionType: null,
};

const userAuthReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {

    case CREATE_ACCOUNT:
      return { ...state, createAccountLoading: true };

    case CREATE_ACCOUNT_SUCCESS:
      return { ...state, createAccountLoading: false };

    case SIGN_IN:
      return {
        ...state,
        signInloading: true,
        email: payload?.email,
        password: payload?.password
      };

    case SIGN_IN_SUCCESS:
      return {
        ...state,
        signInloading: false,
        email: payload?.username,
      };

    case SIGN_IN_MFA:
      return {
        ...state,
        signInloading: false,
        email: payload?.username
      };

    case MFA_AUTHENTICATION:
      return { ...state, mfaloading: true };

    case MFA_SUCCESS:
      return {
        ...state,
        mfaloading: false,
        email: payload?.username,
      };

    case REQUEST_FAILED:
      return {
        ...state,
        mfaloading: false,
        error: payload?.error || 'Something went wrong',
        signInloading: false,
      };

    case TRANSACTION_TYPE:
      return {
        ...state,
        transactionType: payload.TransactionType || payload,
      };

    case FORGET_PASSWORD:
      return {
        ...state,
      };

    case FORGET_PASSWORD_SUCCESS:
      return {
        ...state,
      };

    case CHANGE_PASSWORD:
      return {
        ...state,
      }

    case CLEAR_MFA_ERROR:
      return { ...state, error: null };

    case RESEND_MFA_CODE_SUCCESS:
      return {
        ...state,
        successMessage: payload.message,
        session: payload.session,
        error: null,
      };

    case CLEAR_SUCCESS_MESSAGE:
      return {
        ...state,
        successMessage: null,
        error: null,
      };

    default:
      return state;
  }
};

export default userAuthReducer;
